import { Box } from '@mui/material'
import { SelectC } from 'components'
import { useLoadOrdersCustomers } from 'modules/orders/hooks'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useDebounce } from 'utils'

export const SelectCustomer = () => {
  const [searchCustomer, setSearcCustomer] = useState<string>('')
  const searchCustomerDebounced = useDebounce(searchCustomer, 250)

  const { watch } = useFormContext()

  const { data: customers, isLoading: loadingCustomers } =
    useLoadOrdersCustomers({
      page: 1,
      limit: 100,
      search: searchCustomerDebounced,
      sellerId: watch('seller')?.id,
      filters: {}
    })

  const handleChangeCustomer = (value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setSearcCustomer(value)
  }

  return (
    <SelectC
      name="customerId"
      options={customers?.data || []}
      loading={loadingCustomers}
      label="Cliente"
      onInputChange={(e, value, reason) => handleChangeCustomer(value, reason)}
      getOptionLabel={(option: any) => option?.name}
      renderOption={(props: any, option: any) => (
        <Box component="li" {...props}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>{option.name}</div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                fontSize: 12
              }}
            >
              <div>{option.registration}</div>
              <div style={{ marginLeft: 4, marginRight: 4 }}>|</div>
              <div>{option?.address}</div>
            </div>
          </div>
        </Box>
      )}
    />
  )
}
